module.exports = "<div [innerHTML]=\"content\"> </div>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/static-page/static-page.component.html
// module id = 521
// module chunks = 0